import { lock, unlock } from 'tua-body-scroll-lock';

export function lockBodyScroll(node: HTMLElement) {
  if (node) {
    lock(node);
  }

  return {
    destroy() {
      unlock(node);
    }
  };
}
